var map = {
	"./Antonios.jpg": 198,
	"./Fidelity.png": 199,
	"./Musa.jpg": 200,
	"./SABB.jpeg": 201,
	"./Thapelo.jpg": 202,
	"./Varghese.jpg": 203,
	"./abeed.jpg": 204,
	"./absa.png": 205,
	"./adib.jpg": 206,
	"./axa.png": 207,
	"./bancABC.jpg": 208,
	"./brd.png": 209,
	"./bse.jpg": 210,
	"./caroline.jpg": 211,
	"./cbn.jpg": 212,
	"./citibank.jpg": 213,
	"./consolidated.jpg": 214,
	"./dinesh.jpg": 215,
	"./dtb.png": 216,
	"./evans.jpg": 217,
	"./fnb.png": 218,
	"./fodor.jpg": 219,
	"./ihab.png": 220,
	"./james.jpg": 221,
	"./jenny.jpg": 222,
	"./lance.jpg": 223,
	"./luis.jpg": 224,
	"./mark.jpg": 225,
	"./menash.png": 226,
	"./nbe.jpeg": 227,
	"./ndungu.jpg": 228,
	"./npc.png": 229,
	"./pancreta.png": 230,
	"./radu.jpg": 231,
	"./sanjay.jpg": 232,
	"./sberbank.jpg": 233,
	"./sc.jpg": 234,
	"./speaker.png": 53,
	"./stanbic.png": 235,
	"./zerak.jpg": 236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 385;